export function validatePhone(raw: string): string | null {
  const digits = raw.replace(/\D/g, '');
  if (digits && (digits.length < 7 || digits.length > 15)) return 'Enter a valid phone number';
  return null;
}

export function validateEmail(email: string): string | null {
  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Enter a valid email address';
  return null;
}

export function validateCvc(cvc: string): string | null {
  if (!cvc) return null;
  if (!/^\d{3,4}$/.test(cvc)) return 'CVC must be 3 or 4 digits';
  return null;
}

export function validateCardNumber(cardNumber: string): string | null {
  if (!cardNumber) return null;
  const digits = cardNumber.replace(/\s/g, '');
  if (!/^\d+$/.test(digits)) return 'Card number must contain only digits';
  if (digits.length < 13 || digits.length > 19) return 'Enter a valid card number';
  return null;
}
